import { InputHTMLAttributes } from 'react';
import { useTranslation } from 'react-i18next';

import { collectFormErrors } from '../../../../utils/collect-form-errors';
import { Button } from '../../../atoms/button/button';
import { FormError } from '../../../atoms/form-error/form-error';
import { Header } from '../../../atoms/header/header';
import { Text } from '../../../atoms/text/text';

const VerificationHeader = ({ title, description }: { readonly title?: string; readonly description?: string }) => {
  return (
    <>
      {title ? <Header level="h1">{title}</Header> : null}
      <Text>{description}</Text>
    </>
  );
};

type BaseCaptureFormProps = {
  readonly autoComplete?: string;
  readonly buttonLabel: string;
  readonly description?: string;
  readonly errorRequired: string;
  readonly inputLabel?: string;
  readonly inputMode?: InputHTMLAttributes<HTMLInputElement>['inputMode'];
  readonly onSubmit: (value: string) => Promise<void> | void;
  readonly placeholder?: string;
  readonly title?: string;
};

const FormLayout = ({
  buttonLabel,
  children,
  description,
  errorMessages,
  isSubmitting,
  submitHandler,
  title,
}: {
  readonly buttonLabel: string;
  readonly children: React.ReactNode;
  readonly description?: string;
  readonly errorMessages: string[];
  readonly isSubmitting: boolean;
  readonly submitHandler: (event?: React.BaseSyntheticEvent) => Promise<void>;
  readonly title?: string;
}) => (
  <form onSubmit={submitHandler}>
    <div className="flex flex-col gap-6">
      <VerificationHeader description={description} title={title} />
      {children}
      <FormError error={errorMessages.length > 0 ? errorMessages : null} icon="alert-circle" />
      <Button className="w-full" loading={isSubmitting} type="submit">
        {buttonLabel}
      </Button>
    </div>
  </form>
);

const useCollectedErrors = (errors: object) => {
  const { t } = useTranslation();
  return collectFormErrors(errors, t, ['value']);
};

export { type BaseCaptureFormProps, FormLayout, useCollectedErrors };
